module.exports = __webpack_public_path__ + "img/8.4df1f4e9.webp";